export class EmployeeRelationModel
{

    public RelationshipId: Number;
    public RelationshipName: string;
    
}